import React, { useEffect } from 'react';
import { RouteProps, useHistory } from 'react-router-dom';
import { auth } from '../../../utils/auth';

const SSOLogoutCallbackRoute: React.FC<RouteProps> = (): JSX.Element | null => {
    const history = useHistory();

    useEffect(() => {
        const handleCallback = async () => {
            try {
                await auth.revokeTokenAndClearCookies();
                history.replace('/');
            } catch (error) {
                console.error('Authentication error:', error);
                history.replace('/');
            }
        };

        handleCallback();
    }, []);

    return null;
};

export default SSOLogoutCallbackRoute;
